
import { serverApi } from '../../core';

import { Log } from '../../core';
let log = Log.getLogger('MultiSceneForApp.print.server.print');

function getDefinition(projectId, debug, callback) {
    serverApi.callFunctionGet(
        'print', null, 'getDefinition',
        [
            ['project', projectId],
            ['debug', debug]
        ],
        serverApi.OUTPUT_TYPE_JSON,
        (err, response) => {
            if (callback) {
                if (err) {
                    log.warn(`print.server.print.getDefinition() failed`);
                }
                callback(
                    err,
                    (response && response.reportDefinition) ? response.reportDefinition : null
                );
            }
        }
    );
}

export {
    getDefinition
};
